import { communityCopy, formatNominationMonth, formatNominationNumber } from '@/nominations/communityCopy'
import { NominationAvatar } from '@/nominations/components/NominationAvatar'
import type { NominationConfig } from '@/nominations/types'

type NomineeCardProps = {
  nomination: NominationConfig
}

export const NomineeCard = ({ nomination }: NomineeCardProps) => {
  const { nominee, nominator } = nomination
  const displayName = nominee.credentials ? `${nominee.fullName}, ${nominee.credentials}` : nominee.fullName

  return (
    <article className="nom-card" aria-label={`Nomination card for ${nominee.fullName}`}>
      <div className="nom-card-head">
        <span className="nom-label">{communityCopy.cardEyebrow}</span>
        <span className="nom-number">{formatNominationNumber(nomination.number)}</span>
      </div>

      <div className="nom-card-identity">
        <NominationAvatar monogram={nominee.monogram} photo={nominee.photo} size="lg" />
        <div className="nom-card-who">
          <h2 className="nom-card-name">{displayName}</h2>
          <p className="nom-card-role">{nominee.role ? `${nominee.role}, ${nominee.firm}` : nominee.firm}</p>
          {nominee.location ? <p className="nom-card-location">{nominee.location}</p> : null}
        </div>
      </div>

      <div className="nom-card-foot">
        <div className="nom-card-nominator">
          <NominationAvatar monogram={nominator.monogram} photo={nominator.photo} size="sm" />
          <p className="nom-card-nominator-copy">
            <span className="nom-label">{communityCopy.cardPutForwardBy}</span>
            <span className="nom-card-nominator-name">{nominator.fullName}</span>
            <span className="nom-card-nominator-role">{nominator.role}</span>
          </p>
        </div>
        <time className="nom-card-date" dateTime={nomination.nominatedOn}>
          {formatNominationMonth(nomination.nominatedOn)}
        </time>
      </div>
    </article>
  )
}
